var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',{attrs:{"height":"676px","indicator-position":"outside"}},_vm._l((_vm.bannerList),function(item,i){return _c('el-carousel-item',{key:i},[_c('img',{staticClass:"img",attrs:{"src":item.image,"alt":""}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }